import { GradeTheme } from "@euka-mfes/bark";
import { getProductFamilyForGradeCode } from "./productFamilyGrades";

export const getIsAchievementsEnabled = (achievementsEnabled?: boolean) =>
  achievementsEnabled ?? false;

export const getIsUploadPractiseSectionEnabled = (
  uploadPractiseSectionEnabled?: boolean
) => uploadPractiseSectionEnabled ?? false;

export const getIsUploadActivitySheetEnabled = (
  uploadActivitySheetEnabled?: boolean
) => uploadActivitySheetEnabled ?? false;

export const getIsChatEnabled = (chatEnabled?: boolean) => chatEnabled ?? false;

export const getIsLessonAudioEnabled = (lessonAudioEnabled?: boolean) =>
  lessonAudioEnabled ?? false;

export const getIsLessonImageEnlargementEnabled = (
  lessonImageEnlargementEnabled?: boolean
) => lessonImageEnlargementEnabled ?? false;

// BLD2-363: Assignment submission panel — off until submission slices are ready
export const getIsAssignmentSubmitPanelEnabled = (
  assignmentSubmitPanelEnabled?: boolean
) => assignmentSubmitPanelEnabled ?? false;

/**
 * Returns true if assignment work sample uploads should be shown.
 *
 * BLD2-676: Work samples are scoped to F-10 non-assessed assignments only.
 * Senior grades (11-12) never show work samples — those use the
 * submission-for-marking flow instead. Assessed terms also suppress work
 * samples regardless of grade.
 *
 * @param grade     - Grade context with the work sample uploads flag and grade code
 * @param isAssessed - Whether the current term is assessed (from getIsAssessed)
 * @returns true if work sample features should be shown
 */
export const getIsAssignmentWorkSampleUploadsEnabled = (
  grade:
    | { assignmentWorkSampleUploadsEnabled?: boolean; grade_code?: number }
    | null
    | undefined,
  isAssessed: boolean
): boolean => {
  const flagEnabled = grade?.assignmentWorkSampleUploadsEnabled ?? false;
  const isSeniorGrade =
    getProductFamilyForGradeCode(grade?.grade_code ?? 0) === GradeTheme.Senior;
  return flagEnabled && !isAssessed && !isSeniorGrade;
};
